import { brandSelectorConfig } from 'components/SurveyCreator/EditorConfig/CustomProperties/brandSelector';
import { commentConfig } from 'components/SurveyCreator/EditorConfig/CustomProperties/comment';
import { dropdownConfig } from 'components/SurveyCreator/EditorConfig/CustomProperties/dropdown';
import { itemvalueConfig } from 'components/SurveyCreator/EditorConfig/CustomProperties/itemvalue';
import { multipletextitemConfig } from 'components/SurveyCreator/EditorConfig/CustomProperties/multipletextitem';
import { pageConfig } from 'components/SurveyCreator/EditorConfig/CustomProperties/page';
import { panelConfig } from 'components/SurveyCreator/EditorConfig/CustomProperties/panel';
import { questionConfig } from 'components/SurveyCreator/EditorConfig/CustomProperties/questions';
import { radiogroupConfig } from 'components/SurveyCreator/EditorConfig/CustomProperties/radiogroup';
import { surveyConfig } from 'components/SurveyCreator/EditorConfig/CustomProperties/survey';
import { textConfig } from 'components/SurveyCreator/EditorConfig/CustomProperties/text';
import { translatableConfig } from 'components/SurveyCreator/EditorConfig/CustomProperties/translatable';
import { checkboxConfig } from './checkbox';
import { panelDynamicConfig } from './panelDynamic';

export const customProperties = [
  { name: 'checkbox', properties: checkboxConfig },
  { name: 'comment', properties: commentConfig },
  { name: 'radiogroup', properties: radiogroupConfig },
  { name: 'dropdown', properties: dropdownConfig },
  { name: 'survey', properties: surveyConfig },
  { name: 'itemvalue', properties: itemvalueConfig },
  { name: 'text', properties: textConfig },
  { name: 'page', properties: pageConfig },
  { name: 'question', properties: questionConfig },
  { name: 'panel', properties: panelConfig },
  { name: 'multipletextitem', properties: multipletextitemConfig },
  { name: 'translatable', properties: translatableConfig },
  { name: 'brandselector', properties: brandSelectorConfig },
  { name: 'panelDynamic', properties: panelDynamicConfig },
];
